export default __webpack_public_path__ + "static/media/schedule.ea00cd36.svg";